import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Colors } from "../constants/Colors";

export const Settings = () => {
  const loginType = localStorage.getItem("login_type");
  const isMobile = window.innerWidth <= 570;
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);

  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const handleLanguageChange = (event) => {
    console.log("Language selector triggered"); // To confirm if the function is called
    const selectedLanguage = event.target.value;
    console.log("Selected language value:", selectedLanguage);
    i18n
      .changeLanguage(selectedLanguage)
      .then(() => {
        console.log("Language changed to:", i18n.language);
      })
      .catch((err) => {
        console.error("Failed to change language:", err);
      });
    console.log("Language changed to:", i18n.language);
  };

  useEffect(() => {
    // const { i18n } = useTranslation(); // Using the hook to access i18n
    console.log("Initial language:", i18n.language); // This should now work
    console.log("i18n object:", i18n); // This should now work
    console.log("182.languages:", i18n.languages); // This should now work
    // console
  }, [i18n]);

  if (!loginType) return null;

  return (
    <div
      style={{
        padding: "2rem 1rem 0 1rem",
        width: "100%",
        //   height: "100%",
        display: "flex",
        //   justifyContent: "center",
        overflow: "auto",
      }}
    >
      <div
        style={{
          flexGrow: "1",
          display: "grid",
          // gridTemplateRows: "4fr 5.5fr",
          gap: "1rem",
        }}
      >
        {/* Header */}
        <div
          style={{
            fontSize: "1.25rem",
            marginBottom: "0.5rem",
            fontWeight: "bold",
          }}
        >
          {i18n.t("settings.settings")}
        </div>

        {/* General Section */}
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "1rem",
            boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
          }}
        >
          <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            {i18n.t("settings.generalSettings")}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0.5rem 0",
              alignItems: "center",
            }}
          >
            <span>{i18n.t("settings.setNotification")}</span>
            <label
              style={{
                position: "relative",
                display: "inline-block",
                width: "40px",
                height: "20px",
              }}
            >
              <input
                type="checkbox"
                checked={notificationsEnabled}
                onChange={() => setNotificationsEnabled(!notificationsEnabled)}
                style={{ display: "none" }}
              />
              <span
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  backgroundColor: notificationsEnabled ? Colors.primary100 : "#ccc",
                  borderRadius: "10px",
                  transition: ".4s",
                }}
              ></span>
              <span
                style={{
                  position: "absolute",
                  height: "14px",
                  width: "14px",
                  borderRadius: "50%",
                  backgroundColor: "white",
                  top: "3px",
                  left: notificationsEnabled ? "22px" : "4px",
                  transition: ".4s",
                }}
              ></span>
            </label>
          </div>
          <div style={{ padding: "0.5rem 0" }}>
            <span>{i18n.t("settings.language")}</span>
            <span style={{ float: "right" }}>
              <select
                name="language"
                style={{
                  padding: "5px",
                  borderRadius: "5px",
                  border: "1px solid #ececec",
                  width: "10rem",
                }}
                onChange={handleLanguageChange}
                value={i18n.language}
              >
                <option value="id">Indonesia</option>
                <option value="en">English</option>
              </select>
            </span>
          </div>
        </div>

        {/* About Section */}
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "1rem",
            boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
          }}
        >
          <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
            {i18n.t("settings.about")}
          </div>
          {["aboutUs", "FAQ"].map((item, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "0.5rem 0",
                alignItems: "center",
                borderTop: index !== 0 ? "1px solid #ddd" : "none",
              }}
            >
              <span>{i18n.t("settings." + item)}</span>
              <span
                style={{
                  fontSize: "1.25rem",
                  color: Colors.primary100,
                  cursor: "pointer",
                }}
                onClick={() => {
                  item === "aboutUs"
                    ? navigate("/settings/about-us")
                    : navigate("/settings/faq");
                }}
              >
                →
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
